import { getJWTToken } from '../../utils/jwt';

export const normalizeUrl = (url: string | undefined): string => {
  if (!url) return '';
  return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
};

export const addProtocol = (url: string): string => {
  if (!url) return '';
  if (import.meta.env.DEV && (url.startsWith('localhost') || url.startsWith('127.0.0.1'))) {
    return `http://${url}`;
  }
  return url.startsWith('http') ? url : `https://${url}`;
};

export const getStreamingBaseUrl = (): string => {
  const candidates = [
    import.meta.env?.VITE_TINY_AI_STREAMING_URL,
    typeof process !== 'undefined' ? process.env?.VITE_TINY_AI_STREAMING_URL : undefined,
    typeof process !== 'undefined' ? process.env?.TINY_AI_STREAMING_URL : undefined,
  ].filter((value): value is string => !!value && !value.includes('url-unavailable'));

  const rawUrl = candidates[0] || (import.meta.env.DEV ? 'http://localhost:3010/trpc' : undefined);

  if (!rawUrl) {
    throw new Error('VITE_TINY_AI_STREAMING_URL must be defined to point chat traffic at the streaming service');
  }

  const normalized = addProtocol(normalizeUrl(rawUrl));
  return normalized.endsWith('/trpc') ? normalized : `${normalized}/trpc`;
};

export const getStreamingEventSourceUrl = () => {
  const baseUrl = getStreamingBaseUrl();

  if (typeof window === 'undefined') {
    return baseUrl;
  }

  const token = getJWTToken();
  if (!token) {
    return baseUrl;
  }

  try {
    const url = new URL(baseUrl);
    url.searchParams.set('token', token);
    return url.toString();
  } catch (err) {
    console.warn('Invalid streaming URL configuration; using base string', { baseUrl, err });
    const separator = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${separator}token=${encodeURIComponent(token)}`;
  }
};

export const getAuthHeaders = (): Record<string, string> => {
  const token = getJWTToken();
  if (!token) {
    return {};
  }
  return {
    Authorization: `Bearer ${token}`,
  };
};
